import { Component } from '@angular/core';

@Component({
  selector: 'app-connector-status-info',
  templateUrl: './connector-status-info.component.html',
  styleUrl: './connector-status-info.component.scss',
  standalone: false,
})
export class ConnectorStatusInfoComponent {}
